// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uLLQ","top":"styles_top__2qh-W","left":"styles_left__2zbtZ","description":"styles_description__2Av-5"};